import React, { useEffect, useState, useRef } from "react";
import "./style.css";

// import GirlClap from "../../assets/images/GiF/girl-clap.gif";
import GirlClap from "../../assets/images/GiF/girl-clap.gif";
import Sparkle from "../../assets/images/GiF/sparkel.gif";
import GirlChar from "../../assets/images/girl-char.png";
import Bubble from "../../assets/images/bubble.png";
import parse from "html-react-parser";
import {
  playSpeech,
  playSpeechTTS,
  stopSpeechTTS,
} from "../../utils/playSpeech";
import PointingGif from "../../assets/images/GiF/pointing-hand.gif";
import { stopLayeredSVGAudio } from "../../pages/categories/LayeredSVG";
import { useAuth } from "../../context/AuthContext";
import ClickScreenAUD from "../../assets/audios/Click the screen.wav";
import IncompleteAUD from "../../assets/audios/You have complete.wav";
import { playSpeechKokoro } from "../../utils/playSpeechKokoro";
import { stopSpeechKokoro } from "../../utils/playSpeechKokoro";

function DialogueWrapper({ children, audioSRC }) {
  const [showHand, setShowHand] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHand(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="layout-wrapper" onClick={stopSpeechKokoro}>
      <div className="gir-char-div">
        <img src={GirlChar} alt="Girl Character" className="girl-char" />
      </div>
      <div className="bubble bubble-bottom-right">{children}</div>
      {audioSRC && <audio src={audioSRC} autoPlay />}
      <div className="hand-cursor-small">
        <img src={PointingGif} alt="Hand Cursor" />
      </div>
      {/* {showHand && (
        <div className="hand-cursor-small">
          <img src={PointingGif} alt="Hand Cursor" />
        </div>
      )} */}
    </div>
  );
}

export function GreatJobKiddo({ isActive }) {
  const { setCommonError } = useAuth();
  useEffect(() => {
    stopLayeredSVGAudio();
    if (isActive) playSpeech("Have fun Learning, KIDDO!");
    // if (isActive) playSpeechTTS("Have fun Learning, KIDDO!", setCommonError);
  }, [isActive]);

  return (
    <div className="layout-wrapper">
      <img src={GirlChar} alt="Girl Character" className="click-girl-char" />
      <div className="bubble">
        <img src={Bubble} alt="Speech Bubble" className="click-bubble-bg" />
        <p className="click-text">Have fun Learning, KIDDO!</p>
      </div>
      <div className="hand-cursor-overlay">
        <img src={PointingGif} alt="Hand Cursor" />
      </div>
    </div>
  );
}

export function ClickToListen({ isActive }) {
  const { setCommonError, selectedLang } = useAuth();
  // console.log("Selected Language in ClickToListen: guidance", selectedLang);
  useEffect(() => {
    stopLayeredSVGAudio();
    stopSpeechKokoro();
    if (isActive) playSpeechKokoro("Click the screen to start learning!");
    // if (isActive) playSpeechTTS("Click me, to Start Learning!", setCommonError);
  }, [isActive]);

  return (
    <div className="layout-wrapper-left" onClick={stopSpeechKokoro}>
      <div className="click-gir-char-div">
        <img src={GirlChar} alt="Girl Character" className="click-girl-char" />
      </div>
      <audio src={null} autoPlay />
      <div
        className={`bubble-left ${selectedLang?.code !== "en" ? "j-lang" : ""}`}
      >
        Click the screen to start learning!
      </div>
      <div className="hand-cursor-small-click">
        <img src={PointingGif} alt="Hand Cursor" />
      </div>
    </div>
  );
}

export function GreatKiddo({ isActive }) {
  const { setCommonError } = useAuth();
  useEffect(() => {
    stopLayeredSVGAudio();
    if (isActive) playSpeech("Great job, kiddo!");
    // if (isActive) playSpeechTTS("Great job, kiddo!", setCommonError);
  }, [isActive]);

  return (
    <div className="layout-wrapper">
      <img src={GirlChar} alt="Girl Character" className="click-girl-char" />
      <div className="bubble">
        <img src={Bubble} alt="Speech Bubble" className="click-bubble-bg" />
        <p className="click-text">Great job, kiddo!</p>
      </div>
    </div>
  );
}

export function IntroMessage({
  description,
  subtopicName,
  isActive,
  audioFile,
}) {
  const { setCommonError } = useAuth();
  const audioRef = useRef(null);

  const cleanDesc =
    typeof description === "string"
      ? description.replaceAll("<p>", "").replaceAll("</p>", "")
      : "";

  useEffect(() => {
    stopLayeredSVGAudio();

    // Only play when active and audioFile exists
    if (isActive && audioFile && audioRef.current) {
      // Stop any currently playing audio before starting
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((err) => {
        console.error("Audio play failed:", err);
        setCommonError(err.message);
      });
    }
    if (isActive) stopSpeechKokoro();
    playSpeechKokoro(
      `We are going to learn about ${subtopicName} by ${cleanDesc}. Let's learn, shall we?`,
    );
    //   playSpeechTTS(
    //     `We are going to learn about ${subtopicName} by ${cleanDesc}. Let's learn, shall we?`
    //     , setCommonError);

    // Cleanup when component unmounts or becomes inactive
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [isActive, audioFile, subtopicName, cleanDesc]);

  return (
    <DialogueWrapper>
      <p>
        We are going to learn about <br />
        <span className="topic-title">{subtopicName}</span> by{" "}
        {parse(cleanDesc)}.
      </p>

      {/* {audioFile && <audio ref={audioRef} src={audioFile} />} */}

      <p>Let’s learn, shall we?</p>
    </DialogueWrapper>
  );
}

export function NextMessage({ isActive, nextDescription, audioFile }) {
  const { setCommonError } = useAuth();
  const audioRef = useRef(null);
  const cleanDesc =
    typeof nextDescription === "string"
      ? nextDescription.replaceAll("<p>", "").replaceAll("</p>", "")
      : "";
  useEffect(() => {
    stopLayeredSVGAudio();
    if (isActive && audioFile && audioRef.current) {
      // Stop any currently playing audio before starting
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((err) => {
        console.error("Audio play failed:", err);
        setCommonError(err.message);
      });
    }
    stopSpeechKokoro();
    if (isActive) playSpeechKokoro(`Great, Let’s move to "${cleanDesc}"!`);
    // if (isActive) playSpeechTTS(`Great, Let’s move to "${cleanDesc}"`, setCommonError);
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [isActive, audioFile, cleanDesc]);
  return (
    <div className="layout-wrapper" onClick={stopSpeechKokoro}>
      <div className="sparkle-wrapper">
        <div className="gir-char-div-gif">
          <img src={GirlClap} alt="Girl Character" className="girl-char" />
        </div>
        <div>
          <img src={Sparkle} alt="Sparkles" className="sparkles" />
        </div>

        {/* {audioFile && <audio ref={audioRef} src={audioFile} />} */}
      </div>

      <div className="bubble bubble-bottom-right-gif">
        Great, Let’s move to "{cleanDesc}"
      </div>
    </div>
  );
}

export function IncompleteMessage({
  isActive,
  message = "You haven’t completed this level yet. Please finish it to move on to the next one!",
}) {
  const { setCommonError } = useAuth();
  useEffect(() => {
    stopLayeredSVGAudio();
    if (isActive) stopSpeechKokoro(); 
    playSpeechKokoro(message);
  }, [isActive]);

  return (
    <DialogueWrapper audioSRC={null}>
      <p>{message}</p>
    </DialogueWrapper>
  );
}

// import React, { useEffect } from "react";
// import "./style.css";
// import GirlChar from "../../assets/images/girl-char.png";
// import Bubble from "../../assets/images/bubble.png";
// import parse from "html-react-parser";
// import useAutoSpeech from "../../hooks/useAutoSpeech";
// import { useAuth } from "../../context/AuthContext";

// function DialogueWrapper({ children }) {
//   return (
//     <div className="layout-wrapper">
//       <img src={GirlChar} alt="Girl Character" className="girl-char" />
//       <div className="bubble">
//         <img src={Bubble} alt="Speech Bubble" className="bubble-bg" />
//         <div className="dialogue-text">{children}</div>
//       </div>
//     </div>
//   );
// }

// export function GreatJobKiddo({ isActive }) {
//   const { auth } = useAuth();
//   const message = "Great job, kiddo!";
//   const audio = useAutoSpeech(isActive ? message : null, auth.token);

//   return (
//     <>
//       {audio}
//       <div className="layout-wrapper">
//         <img src={GirlChar} alt="Girl Character" className="click-girl-char" />
//         <div className="bubble">
//           <img src={Bubble} alt="Speech Bubble" className="click-bubble-bg" />
//           <p className="click-text">{message}</p>
//         </div>
//       </div>
//     </>
//   );
// }

// export function ClickToListen({ isActive }) {
//   const { auth } = useAuth();
//   const message = "Click me to start learning!";
//   const audio = useAutoSpeech(isActive ? message : null, auth.token);

//   return (
//     <>
//       {audio}
//       <div className="layout-wrapper">
//         <img src={GirlChar} alt="Girl Character" className="click-girl-char" />
//         <div className="bubble">
//           <img src={Bubble} alt="Speech Bubble" className="click-bubble-bg" />
//           <p className="click-text">{message}</p>
//         </div>
//       </div>
//     </>
//   );
// }

// export function IntroMessage({ description, subtopicName, isActive }) {
//   const { auth } = useAuth();
//   const cleanDesc =
//     typeof description === "string"
//       ? description.replaceAll("<p>", "").replaceAll("</p>", "")
//       : "";

//   const message = `We are going to learn about ${subtopicName} by ${cleanDesc}. Let's learn, shall we?`;
//   const audio = useAutoSpeech(isActive ? message : null, auth.token);

//   return (
//     <>
//       {audio}
//       <DialogueWrapper>
//         <p>
//           We are going to learn about{" "}
//           <span className="topic-title">{subtopicName}</span> by {parse(cleanDesc)}.
//         </p>
//         <p>Let’s learn, shall we?</p>
//       </DialogueWrapper>
//     </>
//   );
// }

// export function IncompleteMessage({ isActive }) {
//   const { auth } = useAuth();
//   const message =
//     "You haven’t completed this level yet. Please finish it to move on to the next one!";
//   const audio = useAutoSpeech(isActive ? message : null, auth.token);

//   return (
//     <>
//       {audio}
//       <DialogueWrapper>
//         <p>You haven’t completed this level yet,</p>
//         <p>please finish it to move on to the next one!</p>
//       </DialogueWrapper>
//     </>
//   );
// }
